import { RouteObject } from 'react-router';
import { ReportingPage } from '@/feature/reporting/ReportingPage';
import { profileRoutes } from '@/feature/profiles/routes';
import { userRoutes } from '@/feature/users/routes';
import { UserSettingsPage } from '@/feature/user-settings';
import { OrganizationSettingsPage } from '@/feature/organization-settings';
import { Notfound } from '@/components';
import {
  Login,
  ResetPassword,
  ResetPasswordConfirm,
  MfaConfirm,
  NewPasswordRequired,
} from '@/feature/authentication';
import { ProtectedRoute } from './ProtectedRoute';
import { PublicRoute } from './PublicRoute';
import { Layout } from './Layout';
import { patientRoutes } from '@/feature/patients/routes';
import { Permission } from '@/utils/roles';

export const routes: RouteObject[] = [
  {
    path: '/login',
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },
  {
    path: '/mfa-verification',
    element: (
      <PublicRoute>
        <MfaConfirm />
      </PublicRoute>
    ),
  },
  {
    path: '/forgot-password',
    element: (
      <PublicRoute>
        <ResetPassword />
      </PublicRoute>
    ),
  },
  {
    path: '/reset-password',
    element: (
      <PublicRoute>
        <ResetPasswordConfirm />
      </PublicRoute>
    ),
  },
  {
    path: '/new-password-required',
    element: (
      <PublicRoute>
        <NewPasswordRequired />
      </PublicRoute>
    ),
  },
  {
    element: <Layout />,
    children: [
      {
        path: '/',
        children: patientRoutes,
      },
      {
        path: '/patients',
        children: patientRoutes,
      },
      {
        path: '/reporting',
        element: (
          <ProtectedRoute requiredPermissions={[Permission.VIEW_REPORTING]}>
            <ReportingPage />
          </ProtectedRoute>
        ),
      },
      {
        path: '/profiles',
        children: profileRoutes,
      },
      {
        path: '/users',
        children: userRoutes,
      },
      {
        path: '/user-settings',
        element: (
          <ProtectedRoute>
            <UserSettingsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: '/organization-settings',
        element: (
          <ProtectedRoute
            requiredPermissions={[Permission.VIEW_ORGANIZATION_SETTINGS]}
          >
            <OrganizationSettingsPage />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <Notfound />,
  },
];
